import {GetSeferData} from "SeferPetach/GetData";

export async function getSectorList() {
    var args = {};
    var payload = await GetSeferData("sf1", args);
    return (payload);
}

export async function getSectorByID(sector_id){
    var args = {
        'SECTOR_ID': sector_id
    };
    var payload = await GetSeferData("sf2", args);
    return (payload);
}

export async function getPermissionList(){
    var args = {};
    var payload = await GetSeferData("auxf1", args);
    return (payload);
}

export async function updateSector(obj) {
    var args = obj;
    var payload = await GetSeferData("sf3", args);
    return (payload);
}

export async function deleteSector(sector_id){
    var args = {
        'SECTOR_ID': sector_id
    };
    var payload = await GetSeferData("sf4", args);
    return (payload);
}